module.exports = __webpack_public_path__ + "src/assets/img/avatar-soco-vm-cola.bd950319.png";